import React, { useState, useEffect } from "react";
import { Container, Row, Col, Tab, Nav, Form, Button } from "react-bootstrap";
import ReactSlider from "react-slider";
import { useLocation } from "react-router-dom"; // <-- for reading URL params
import Sidebar from "./Sidebar";
import Trending from "./Trending";
const Charts = () => {
 

  return (
	<>
    <Trending/>
	</>
  );
};

export default Charts;
